import { cloneDeep } from 'lodash';
import type { Child } from 'src/components/Children/types';

export const childToAPITransform = (data: Child) => {
    const transformedData = cloneDeep(data);
    delete transformedData?.visit?.hospitalDepartment;
    delete transformedData?.visit?.educationCenter;
    delete transformedData?.visit?.educationLevelGroup;
    return transformedData;
};
